import React from "react";
import { Home_IndustriesWeServe_Data } from "../../Constant/Data";

function IndustriesWeServe() {
  const data = Home_IndustriesWeServe_Data;
  return (
    <>
      <section className="py-6 container">
        <div className="container">
          <div className="row" data-aos="fade-in">
            <div className="col-lg-6 mx-auto">
              <h2 className="textt-gradient text-center" data-aos="zoom-in">
                Industries We Serve
              </h2>
            </div>
          </div>
          <div className="row mt-5 ">
            {data.map((item) => (
              <div
                className="col-lg-3 col-md-4 col-12 p-4 cursor-pointer "
                key={item.id}
                // data-aos="zoom-in"
              >
                <div
                  className="card card-background card-background-mask-primary tilt mt-md-0 mt-5 industries-card"
                  style={{
                    height: "200px",
                  }}
                >
                  <div
                    className="full-background"
                    style={{
                      backgroundImage: `url(${item.image})`,
                    }}
                  />
                  <div className="card-body pt-7 text-center  d-flex align-items-end ">
                    <h3 className="text-white up mb-0">{item.title}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default IndustriesWeServe;
